import { ChevronRight } from '@project-lary/react-material-symbols';
import { useGetETSTicketNotificationsCountSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { useIsMobile } from 'gcs-common/design-system/hooks/use-media-query';
import Anchor from 'gcs-common/design-system/ui/anchor';
import { Badge } from 'gcs-common/design-system/ui/badge';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import NotificationBadge from 'gcs-common/design-system/ui/notification-badge';
import etsDesktop from 'gcs-common/icons/ets-desktop.svg';
import etsIcon from 'gcs-common/img/ets_icon.svg';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const EtsDesktopBanner = () => {
  const isMobile = useIsMobile();
  if (!isMobile) {
    return null;
  }
  return (
    <div className="mt-1 flex w-fit items-center gap-1 rounded bg-[#F7EDFD] p-1 px-2">
      <img className="inline-block size-4" src={etsDesktop} alt="EtsIcon" />
      <span className="text-purple text-xs">Jetzt auf Desktop</span>
    </div>
  );
};

const TicketsChannelItem = () => {
  const navigate = useNavigate();
  const isSidebarCollapsed = useSelector(getSidebarCollapsed);
  const ticketNotificationsCount = useGetETSTicketNotificationsCountSelector();

  const navigateToTickets = () => {
    navigate(CHAT_ROUTES.TICKETS);
  };
  return (
    <Anchor
      onClick={navigateToTickets}
      className={`flex items-center gap-4 p-3 pl-4 no-underline hover:bg-neutral-3 active:bg-neutral-4 ${isSidebarCollapsed ? 'justify-center' : 'justify-between'}`}
    >
      <div className="flex items-center gap-2">
        <img className="h-10 w-10" src={etsIcon} alt="EtsIcon" />
        {!isSidebarCollapsed && (
          <div className="flex flex-col">
            <div className="flex items-center justify-center gap-2">
              <span className="text-base text-neutral-12">Ersatzteilanfragen</span>
              <Badge
                variant="soft_neutral"
                type="counter"
                className="rounded bg-[rgba(118,54,140,0.15)] px-2 text-purple text-xs"
              >
                Beta
              </Badge>
            </div>
            <EtsDesktopBanner />
          </div>
        )}
      </div>
      <div className="flex items-center">
        {ticketNotificationsCount > 0 && (
          <NotificationBadge className="size-6 text-center text-white">{ticketNotificationsCount}</NotificationBadge>
        )}
        {!isSidebarCollapsed && (
          <IconButton
            Icon={ChevronRight}
            iconSize="size-6"
            className="cursor-pointer"
            size="m"
            variant="ghost_neutral"
          />
        )}
      </div>
    </Anchor>
  );
};

export default TicketsChannelItem;
